import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import DiariasService from '../../../services/diarias'
import Diaria from './diaria';

const ListarDiarias = () => {


    const [diarias, setDiarias] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchDiarias() {
        const response = await DiariasService.listar();
        if (response.data.length >= 1) {
            setDiarias(response.data)
            setVazio(false)
        } else {
            setDiarias([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchDiarias();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setDiarias={setDiarias}
                    setVazio={setVazio}
                    fetchDiarias={fetchDiarias}
                    diarias={diarias}
                />
            </Fragment>
            {vazio ? <Fragment>
                <Alert variant='danger'>Sua pesquisa não retornou nenhum resultado! :(</Alert>
            </Fragment> :
                <Fragment>
                    <h5>Tabela de Diárias concedidas aos servidores do Município de Macuco</h5><br />
                    <Row xs={12} lg={3}>
                        {diarias.map((diaria, index) =>
                            <Diaria
                                diaria={diaria}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarDiarias;